import { ScanLine, Search } from "lucide-react";
import { Avatar } from "@/components/shared/Avatar";
import { NotificationBell } from "@/components/NotificationBell";
import { GuideDot } from "@/components/GuideNudge";

// Horní lišta varianty B na mobilu (194): místo plného pruhu plovoucí skleněné
// ostrůvky — profil, hledání a menu (+ sken dokladu pro vedení/účetní), upozornění (200).
// Obsah stránky jede pod nimi; mezi ostrůvky na obsah nic nesahá (pointer-events).
// 203: lupa a „Hledat“ tmavé (ne šedé) — přes odrolovanou tmavou kartu směny zůstanou čitelné.
// 349: avatar otevře okno profilu (firma, Můj profil, Nastavení, režim, odhlášení) — jediné
//   místo pro účet; menu pod „Hledat“ má jen moduly.
// 303: na barevném pozadí (298) hustší sklo (pp-gw--top); u zvonečku je sklo vrstva pod
//   tlačítkem, ne na něm — Safari na iPhonu jinak zakalí i odznak s počtem.
export default function MobileHeader({ user, onProfile, onSearch, onScan, menuOpen, hidden }) {
  return (
    <header data-testid="mobile-header" aria-hidden={hidden ? "true" : undefined}
      className="md:hidden fixed top-0 inset-x-0 z-30 flex items-center gap-2 px-3.5 pb-2 pointer-events-none"
      style={{ paddingTop: "max(14px, calc(env(safe-area-inset-top) + 6px))" }}>
      {/* 306: tečka „nastavení není dokončené“ vedle avataru — ne uvnitř, pp-round by ji ořízl */}
      <span className="relative shrink-0 pointer-events-auto">
        <button type="button" onClick={onProfile} aria-label="Můj profil" data-testid="mobile-profile-btn"
          className="pointer-events-auto shrink-0 rounded-full overflow-hidden pp-round shadow-[0_0_0_2px_hsl(var(--card)),0_4px_12px_rgba(15,15,16,.15)] active:scale-95 transition-transform duration-200 motion-reduce:transition-none">
          {/* Safari při stisku (scale) přestane ořezávat fotku do kruhu — pp-round + kulatý img */}
          <Avatar name={user?.name} photo={user?.photo_url} size={44} className="bg-brand text-white font-bold [&_img]:rounded-full" />
        </button>
        <GuideDot />
      </span>
      <div className="pp-gw pp-gw--top pointer-events-auto flex-1 min-w-0 h-11 rounded-full flex items-center active:scale-[.98] transition-transform duration-200 motion-reduce:transition-none">
        <button type="button" onClick={onSearch} data-testid="mobile-search-btn" aria-haspopup="dialog" aria-expanded={menuOpen ? "true" : "false"}
          aria-label="Hledat a menu"
          className="flex-1 min-w-0 h-11 flex items-center gap-2 pl-3.5 pr-1 text-[16px] text-foreground text-left">
          <Search size={19} className="shrink-0" aria-hidden="true" /><span className="truncate">Hledat</span>
        </button>
        {onScan && (
          <>
            <span aria-hidden="true" className="w-px h-[22px] bg-border shrink-0" />
            <button type="button" onClick={onScan} aria-label="Nahrát fakturu nebo účtenku" data-testid="mobile-scan-btn"
              className="w-[46px] h-11 grid place-items-center text-brand shrink-0">
              <ScanLine size={21} aria-hidden="true" />
            </button>
          </>
        )}
      </div>
      {/* 200: vpravo zvoneček místo tlačítka menu — menu i hledání otevírá pole Hledat */}
      <div className="pointer-events-auto shrink-0 relative active:scale-95 transition-transform duration-200 motion-reduce:transition-none">
        <span aria-hidden="true" className="pp-gw pp-gw--top absolute inset-0 rounded-full" />
        <NotificationBell placement="top" triggerClassName="h-11 w-11 rounded-full" iconSize={20} />
      </div>
    </header>
  );
}
